import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import OrderNotePrompt from 'emun.order/order-note-prompt'


function OrderNotePromptDirective($window, $parse, $session) {
  // Introduce custom elements for IE8
  $window.document.createElement('order-note-prompt');
  return {
    scope: false,
    link: function (scope, element, attr) {
      var onNoteCreated = attr.onNoteCreated || attr.onNoteSaved;

      var $targets = (attr.orderNotePromptClickSelector ? element.find(attr.orderNotePromptClickSelector) : element);
      $targets.on('click', e => {
        var model = scope.$eval(attr.orderNotePrompt || attr.ngModel || attr.order || attr.note) || {
          order: attr.order,
          note: attr.note
        };
        if (!model.note) {
          model.note = {
            note: '',
            createdBy: $session.userName,
            createdOn: new Date()
          }
        }
        if (model.order) {
          model.note.orderNumber = model.order.id;
        }
        OrderNotePrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
          (saved) => {
            if (attr.onNoteSaved) {
              $parse(attr.onNoteSaved)(scope, { $saved: saved })
            }
          }, () => {
            if (attr.onDismissed) {
              $parse(attr.onDismissed)(scope, {})
            }
          });
      });
    }
  }
};

export default OrderNotePromptDirective;